module.exports = __webpack_public_path__ + "static/Classroom-Activity-1-5-Positive-Affirmations-ES-7fd8ee6c71a294f9b5cb121486be858d.pdf";